import { parseDomain } from '../../utils';
import { dynamicLoadApiClient } from './dynamicLoadApiQueries';
export const queryInitialDomainContacts = async _ref => {
  let httpClient = _ref.httpClient,
    request = _ref.request;
  const _await$dynamicLoadApi = await dynamicLoadApiClient(),
    DomainsApiClient = _await$dynamicLoadApi.DomainsApiClient;
  const _DomainsApiClient$que = DomainsApiClient.queries({
      httpClient
    }),
    domainPurchaseData = _DomainsApiClient$que.domainPurchaseData;
  const domain = parseDomain(request.domainName);
  const _await$domainPurchase = await domainPurchaseData({
      domainName: domain.asciiDomain,
      isRenewal: false
    }),
    purchaseData = _await$domainPurchase.data;
  return {
    initialContacts: parseContactInfo(purchaseData.domainContacts),
    purchaseId: purchaseData.purchaseId
  };
};
export const parseContactInfo = oldPurchaseDataContacts => {
  const contactInfo = ['firstName', 'lastName', 'email', 'company', 'streetAddress', 'city', 'state', 'postalCode', 'countryCode', 'phone', 'language'].reduce((acc, key) => {
    const oldValue = oldPurchaseDataContacts['registrant' + key.charAt(0).toUpperCase() + key.slice(1)];
    if (oldValue) {
      acc[key] = oldValue;
    }
    return acc;
  }, {});
  return {
    registrant: contactInfo,
    admin: contactInfo,
    tech: contactInfo
  };
};
//# sourceMappingURL=domainContacts.js.map